<!--横向滑动景点详情 view:17-->
<template>
    <div class="view16Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip v-if="list.length">
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.imgUrl" :name="item.name" :card-key="ix" :distance="item.distance" :star="item.star" :area="item.area" @on-click="()=>onAsk(item.name,item.id)" :key="`tips-quick-${ix}`" card-type="tour"/>
        </CrossSlip>
        <Empty v-else/>
    </div>
</template>


<script>
    import CrossSlip from "../Use/cross-slip-wrapper";
    import BaseCard from "../Use/base-card";
    import {mapState, mapActions, mapMutations} from "vuex";
    import Empty from '../Use/empty'

    export default {
        name: "View16",
        components: {
            BaseCard, CrossSlip,Empty
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {

            };

        },
        methods: {
            ...mapMutations([
                "setNewsContent"
            ]),
            onAsk(name,id) {
                this.$emit('on-ask',name,id)
            },


        }
    };
</script>
<style lang="less" scoped>
    .view16Wrapper {


    }

</style>
